import sw from '@uswitch/ev-utils/lib/switch'
import loadable from '@loadable/component'
import { useEntities, useBrand } from '@uswitch/ev-utils/lib/context/selectors'
import withComponentBase from '../../helpers/with-component-base'

const SubNavigationCollection = loadable(() => import('./sub-navigation-collection'))
const SubNavigationBlocks = loadable(() => import('./sub-navigation-blocks'))

const SubNavigation = ({ variant, lists = [], ...props }) => {
  const brand = useBrand()
  const linkListEntities = useEntities(lists).map(({ links, subtitle }) => ({
    links,
    subtitle,
  }))

  return sw({
    default: () => (
      <SubNavigationCollection
        {...props}
        lists={lists}
        brand={brand}
        linkListEntities={linkListEntities}
      />
    ),
    'Collection of links': () => (
      <SubNavigationCollection
        {...props}
        lists={lists}
        brand={brand}
        linkListEntities={linkListEntities}
      />
    ),
    Blocks: () => (
      <SubNavigationBlocks
        {...props}
        lists={lists}
        brand={brand}
        linkListEntities={linkListEntities}
      />
    ),
  })(variant, { lists, brand, linkListEntities, props })
}

export default withComponentBase(SubNavigation, ({ variant }) => ({
  withHeaderFooter: true,
  withContainer: true,
  withPalette: true,
  defaultPalette: { ...(variant === 'Blocks' && { backgroundColor: 'grey-05' }) },
  headerStyles: {
    ...(variant === 'Collection of links'
      ? { mt: ['lg'], width: ['100%', '70%', '70%'] }
      : { mt: ['xl', 'xxl'] }),
  },
  wrapperStyles: {
    ...(variant === 'Collection of links' ? { position: 'relative' } : {}),
  },
  footerStyles: {
    mt: 16,
    mb: ['xl', 'xxl'],
  },
}))
